import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const ConfirmDialog = ({
  open,
  title = 'Confirm Action',
  message = 'Are you sure?',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  destructive = true,
  loading = false,
  onConfirm,
  onCancel,
  testIdPrefix = 'confirm',
}) => {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !loading) onCancel();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)' }}
      onClick={handleBackdropClick}
      data-testid={`${testIdPrefix}-dialog`}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6"
        style={{ border: '1px solid #E5E0D8' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: destructive ? '#FEE2E2' : '#F5E6F5' }}
          >
            <AlertTriangle size={24} style={{ color: destructive ? '#EF4444' : '#990099' }} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold mb-1" style={{ color: '#2D3A2A', fontFamily: 'Outfit, sans-serif' }}>
              {title}
            </h3>
            <p className="text-sm" style={{ color: '#6B7280' }}>
              {message}
            </p>
          </div>
          <button
            onClick={onCancel}
            disabled={loading}
            className="p-1 rounded hover:bg-gray-100 transition-colors flex-shrink-0"
            data-testid={`${testIdPrefix}-close-btn`}
          >
            <X size={20} style={{ color: '#6B7280' }} />
          </button>
        </div>

        <div className="flex gap-3 justify-end mt-6">
          <button
            onClick={onCancel}
            disabled={loading}
            className="secondary-btn px-5"
            data-testid={`${testIdPrefix}-cancel-btn`}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-5 py-2 rounded-lg font-medium text-white transition-colors"
            style={{
              backgroundColor: destructive ? '#EF4444' : '#990099',
              opacity: loading ? 0.6 : 1,
            }}
            data-testid={`${testIdPrefix}-action-btn`}
          >
            {loading ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
